import { BaseModel } from "sjs-base-model";

export default class NuovoMessaggioFormModel extends BaseModel {
    public readonly tipologiaMessaggio: string = "";
    public readonly inviaABanca: boolean = false;
    public readonly a: string = "";
    public readonly cc: string = "";
    public readonly oggetto: string = "";
    public readonly dipendente: string = "";
    public readonly testo: string = "";

    constructor(data: Partial<NuovoMessaggioFormModel>) {
        super();

        this.update(data);
    }
}
